import { useCompanySetting } from "Components/CompanySetting/hooks/useCompanySetting";
import moment, { Moment } from "moment";
import { TIME_FORMAT } from "../constants/TIME_FORMAT";
import { getCompanyWorkingHours } from "./getCompanyWorkingHours";

export function useSetWorkingHours() {
	const companySetting = useCompanySetting((state) => state.item);
	const workingHours = getCompanyWorkingHours(companySetting);
	const workingHoursStart = moment(workingHours.start, TIME_FORMAT);
	const workingHoursEnd = moment(workingHours.end, TIME_FORMAT);

	return (date: Moment, side: "start" | "end") => {
		return date.set({
			hour:
				side === "start" ? workingHoursStart.hour() : workingHoursEnd.hour(),
			minute:
				side === "start"
					? workingHoursStart.minute()
					: workingHoursEnd.minute(),
		});
	};
}
